import { render, staticRenderFns } from "./GBHeaderSimpleDisplaySwitch.vue?vue&type=template&id=b8d2ee00&scoped=true&"
import script from "./GBHeaderSimpleDisplaySwitch.vue?vue&type=script&lang=js&"
export * from "./GBHeaderSimpleDisplaySwitch.vue?vue&type=script&lang=js&"
import style0 from "./GBHeaderSimpleDisplaySwitch.vue?vue&type=style&index=0&id=b8d2ee00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d2ee00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle,VToolbar,VToolbarItems})
